import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-i-dealer-list',
  templateUrl: './i-dealer-list.component.html',
  styleUrls: ['./i-dealer-list.component.css']
})
export class IDealerListComponent implements OnInit {

  dealerList:any = []

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  singleIDealerData:any = []
  first: number = 0;
  isLoading: any = false

  dealerForm: any | FormGroup
  cid:any
  deleteId: any
  distributorList: any = []

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false,
    verify: true,
    approve: true,
    issue: true,
    attach: true,
    remove: true,
  }

    locationList:any = [];
    locationSelectedList:any = [];
    locationDropdownSettings: IDropdownSettings = {
      singleSelection: false,
      idField: 'locationId',
      textField: 'zone',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }


  ngOnInit(): void {


    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action


    this.cid = sessionStorage.getItem('cid')

    this.getAllIDealer(this.pageNumber,this.recordsPerPage);
    this.dealerForm = this.fb.group({
      name: [''],
      phNo: [''],
      email:[''],
      address: [''],
      photoUrl: [''],
      idProofUrl: [''],
      addressProofUrl: [''],
      idistributorId: [''],
    });

    this.getAllIdistributor()
    this.getAllLocation()
  }


  getAllLocation(){
    this.generic_service.getAllLocation().subscribe(
      (res:any)=> {
        this.locationList = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  onItemSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  getAllIdistributor(){
    this.isLoading = true
    this.generic_service.getAllIdistributor(0,1).subscribe(
      (res:any)=> {
        console.log(res)
        if(res && res.response){
          if(res.response.totalRecords != 0){
            this.generic_service.getAllIdistributor(0,res.response.totalRecords).subscribe(
              (response:any)=> {
                console.log(response)
                this.distributorList = response.response.idistributorList
                this.totalRecords = response.response.totalRecords
              },
              (err:any)=>{
                console.log(err)
              }
            )
          }
        }
        
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  idealerUpdateStatus(status: any){

    // status accepted VERIFIED, REQUESTED, APPROVED, REJECTED

    let body = {
      "cid": Number(this.cid),
      "existingCustomerInfoStatus": {
        "note": "",
        "status": status,
        "updatedDate": new Date().getTime()
      },
      "idealerId": this.singleIDealerData[0].idealerId
    }

    this.generic_service.idealerUpdateStatus(body).subscribe(
      (response: any)=>{
        console.log(response)
        this.toastr.success(response.message);
        this.getAllIDealer(this.pageNumber,this.recordsPerPage);
        this.getIDealerById(this.singleIDealerData[0].idealerId)

      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description);

      }
    )
  }


  onTableDataChange(event: any) {
    this.totalRecords = event.page;
    this.getAllIDealer(this.pageNumber,this.recordsPerPage);
  }

  getAllIDealer(pageNumber: any,recordsPerPage:any){
    this.isLoading = true
    this.generic_service.getAllIdealer(pageNumber,recordsPerPage).subscribe(
      (res:any)=> {
        console.log(res)
        this.dealerList = res.response.idealerList

        this.totalRecords = res.response.totalRecords
        this.isLoading = false

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getIDealerById(IDealerId:any){
    this.generic_service.getIdealerById(IDealerId).subscribe(
      (res:any)=>{
        this.singleIDealerData =[]
        this.singleIDealerData.push(res.response)
        console.log(res)
      }
    )
  }

  onUpload(event: any,type: any) {
    this.generic_service.uploadImage(event.target.files[0]).subscribe(
      (event: any) => {
        console.log(event);
        if(type == 'photoUrl'){
          this.dealerForm.patchValue({photoUrl: event.response});
        }
        if(type == 'idProofUrl'){
          this.dealerForm.patchValue({idProofUrl: event.response});
        }
        if(type == 'addressProofUrl'){
          this.dealerForm.patchValue({addressProofUrl: event.response})
        }
    });
  }

  removeImage(type: any){
    if(type == 'photoUrl'){
      this.dealerForm.patchValue({photoUrl: ""});
    }
    if(type == 'idProofUrl'){
      this.dealerForm.patchValue({idProofUrl: ""});
    }
    if(type == 'addressProofUrl'){
      this.dealerForm.patchValue({addressProofUrl: ""})
    }
  }
  
  addImageBtn(type: any){
    document.getElementById(type)?.click()
  }

add() {
  // Step 1: Build locationObj efficiently using a Map
  const locationMap = new Map(
    this.locationList.map((loc: any) => [loc.locationId, loc])
  );

  const locationObj = this.locationSelectedList
    .map((selected: any) => {
      const matched: any = locationMap.get(selected.locationId);
      if (matched) {
        return {
          locationId: matched.locationId,
          country: matched.country,
          city: matched.city,
          provinceOrState: matched.provinceOrState,
          district: matched.district,
          zone: matched.zone,
          postalCode: matched.postalCode
        };
      }
      return null;
    })
    .filter((loc: any) => loc !== null);

  // Step 2: Prepare request body using the real locationObj
  const body = {
    version: 0,
    isActive: true,
    description: "",
    name: this.dealerForm.get('name')?.value,
    phNo: this.dealerForm.get('phNo')?.value,
    altPhNo: "",
    email: this.dealerForm.get('email')?.value,
    altEmail: "",
    address: this.dealerForm.get('address')?.value,
    photoUrl: this.dealerForm.get('photoUrl')?.value,
    idProofUrl: this.dealerForm.get('idProofUrl')?.value,
    addressProofUrl: this.dealerForm.get('addressProofUrl')?.value,
    lat: "",
    lng: "",
    keyValuePairs: [],
    locationObj: locationObj, // ✅ use the dynamically built list
    latestStatus: "REQUESTED",
    statusList: [
      {
        note: "",
        status: "REQUESTED",
        updatedDate: Date.now()
      }
    ],
    cid: Number(this.cid),
    distributorId: ""
  };

  // Step 3: Call API
  this.generic_service.addIdealer(body).subscribe(
    (response: any) => {
      console.log(response);
      this.cancelModel();
      this.getAllIDealer(this.pageNumber, this.recordsPerPage);
      this.toastr.success(response.message);

      // Reset form fields
      this.dealerForm.patchValue({
        name: "",
        phNo: "",
        email: "",
        address: "",
        photoUrl: "",
        idProofUrl: "",
        addressProofUrl: ""
      });
      this.locationSelectedList = []
    },
    (error: any) => {
      console.error(error);
      this.toastr.error(error?.error?.errors?.[0]?.description || "Something went wrong.");
    }
  );
}


  cancelModel(){
    document.getElementById("closeAdd")?.click()
    document.getElementById("closeDelete")?.click()
    document.getElementById("closeAdd")?.click()
  }


  selectIdealer(id:any){
    this.deleteId = id
  }

  deleteIdealer(){
    this.generic_service.deleteIdealer(this.deleteId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllIDealer(this.pageNumber,this.recordsPerPage);
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }


}






  // const locationMap = new Map(
  //   this.locationList.map((loc: any) => [loc.locationId, loc])
  // );

  // // Build and return the matched objects
  // const locationObj = this.locationSelectedList
  //   .map((selected: any) => {
  //     const matched = locationMap.get(selected.locationId);
  //     if (matched) {
  //       return {
  //         locationId: matched.locationId,
  //         country: matched.country,
  //         city: matched.city,
  //         provinceOrState: matched.provinceOrState,
  //         district: matched.district,
  //         zone: matched.zone,
  //         postalCode: matched.postalCode
  //       };
  //     }
  //     return null;
  //   })
  //   .filter((loc: any) => loc !== null);

  // return locationObj;